const AVATAR_COLORS = ['#e57373', '#64b5f6', '#81c784', '#ffb74d', '#ba68c8', '#4db6ac', '#f06292'];

export function getInitials(name, surname) {
    return `${name?.[0] ?? '?'}${surname?.[0] ?? '?'}`;
}

export function getAvatarColor(name) {
    const index = (name?.charCodeAt(0) ?? 0) % AVATAR_COLORS.length;
    return AVATAR_COLORS[index];
}

export function deriveAttendanceDisplay(attendance) {
    const startHour = 0;

    const workerStartString = attendance.check_in;
    const workerEndString = attendance.check_out;

    const startDate = new Date(workerStartString);
    const endDate = workerEndString !== null ? new Date(workerEndString) : null;

    const startDay = startDate.getDate();
    const endDay = endDate !== null ? endDate.getDate() : null;
    const startMonth = startDate.getMonth() + 1;
    const startYear = startDate.getFullYear();
    const endMonth = endDate !== null ? endDate.getMonth() + 1 : null;
    const endYear = endDate !== null ? endDate.getFullYear() : null;

    const startH = startDate.getHours();
    const startM = startDate.getMinutes();
    const endH = endDate !== null ? endDate.getHours() : null;
    const endM = endDate !== null ? endDate.getMinutes() : null;

    const workerStartMinutes = (startH - startHour) * 60 + startM;
    const workerEndMinutes = endH !== null ? (endH - startHour) * 60 + endM : null;

    const workedMinutes = workerEndMinutes !== null ? workerEndMinutes - workerStartMinutes : null;
    const workedHours = workedMinutes !== null ? Math.floor(workedMinutes / 60) : null;
    const workedRemainingMinutes = workedMinutes !== null ? workedMinutes % 60 : null;

    const now = new Date();
    const currentH = now.getHours();
    const currentM = now.getMinutes();
    const currentMinutes = (currentH - startHour) * 60 + currentM;
    const currentWorkingMinutes = currentMinutes - workerStartMinutes;
    const currentWorkingHours = Math.floor(currentWorkingMinutes / 60);
    const currentRemainingMinutes = currentWorkingMinutes % 60;
    const displayHours = workedMinutes !== null
        ? `${workedHours}h ${workedRemainingMinutes}m`
        : `${currentWorkingHours}h ${currentRemainingMinutes}m`;

    const displayStart = `${String(startH).padStart(2, '0')}:${String(startM).padStart(2, '0')}`;
    const displayEnd = workedMinutes !== null ? `${String(endH).padStart(2, '0')}:${String(endM).padStart(2, '0')}` : null;

    const displayStartDay = `${String(startDay)}`;
    const displayEndDay = workedMinutes !== null ? `${String(endDay)}` : null;
    const displayStartMonth = `${String(startMonth).padStart(2, '0')}`;
    const displayEndMonth = workedMinutes !== null ? `${String(endMonth).padStart(2, '0')}` : null;
    const displayStartYear = `${String(startYear)}`;
    const displayEndYear = workedMinutes !== null ? `${String(endYear)}` : null;

    const displayCheckInDay = `${displayStartDay}.${displayStartMonth}.${displayStartYear}`;
    const displayCheckOutDay = workedMinutes !== null ? `${displayEndDay}.${displayEndMonth}.${displayEndYear}` : null;

    const checkInDateValue = `${displayStartYear}-${displayStartMonth}-${displayStartDay}`;
    const checkOutDateValue = workedMinutes !== null ? `${displayEndYear}-${displayEndMonth}-${displayEndDay}` : null;

    const isOvernightShift = displayCheckOutDay !== null && displayCheckInDay !== displayCheckOutDay;
    const showOvernightWarning = isOvernightShift && workerEndMinutes !== null;

    return {
        workerStartMinutes,
        workerEndMinutes,
        displayStart,
        displayEnd,
        displayHours,
        isOvernightShift,
        showOvernightWarning,
        checkInDateValue,
        checkOutDateValue,
    };
}
